export const REGULAR_FONT_FAMILY = 'SourceSerif4-Regular';
export const TITLE_FONT_FAMILY = 'SourceSerif4-MediumItalic';
export const CONTENT_FONT_FAMILY = 'SourceSans3-Medium';
